/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
class Interval {
  private _interval: number = 0;

  start(callback: Function, delay: number) {
    this._interval = setInterval(callback, delay);
  }

  stop() {
    clearInterval(this._interval);
  }
}

export default Interval;
